// src/belediye/components/mesajlasma/useMsjFeatures.js
// Mesajlaşma özellik-flag'leri — TEK karar noktası (FAZ-37, 12 MD §3/§5).
// ChatDock/ChatThread/NewChatPanel hepsi buradan okur; flag mantığı dağıtılmaz.
//
// `gorev` çifte kapılı: hem mesajlasma.gorev flag'i HEM internal_tasks modülü
// açık olmalı (12 MD §3: "mesajlasma.gorev etkin sayılmak için ek olarak
// internal_tasks modülü açık olmalı — çifte kapı").

import useFeatureEnabled from "../../hooks/useFeatureEnabled";
import useModuleEnabled from "../../hooks/useModuleEnabled";

export default function useMsjFeatures() {
  const serbest = useFeatureEnabled("mesajlasma.serbest");
  const basvuru = useFeatureEnabled("mesajlasma.basvuru");
  const gorevFlag = useFeatureEnabled("mesajlasma.gorev");
  const gorevModulu = useModuleEnabled("internal_tasks");
  return { serbest, basvuru, gorev: gorevFlag && gorevModulu };
}
